import * as palette from "@govlaunch/palette";
import Link, { LinkProps } from "next/link";
import React, { HTMLAttributes } from "react";
import MakersIcon from "~/components/icons/MakersIcon";
import mediaQueries from "~/components/mediaQueries";
import CountBadge from "~/components/profile/CountBadge";
import { Margin } from "~/components/spacings";

interface IVendorOwnerNavbarTabProps {
  title: string;
  active?: boolean;
  count?: number | null;
  dataIntercomTarget?: string | null;
  disabled?: boolean;
  icon: any | null;
  planIcon?: React.ElementType;
  alwaysShowCounter?: boolean;
}

export default function VendorOwnerNavbarTab({
  href,
  as,
  title,
  active,
  count,
  icon: Icon,
  planIcon: PlanIcon = MakersIcon,
  dataIntercomTarget,
  disabled,
  alwaysShowCounter = false,
  ...props
}: IVendorOwnerNavbarTabProps & HTMLAttributes<HTMLAnchorElement> & LinkProps) {
  return (
    <div
      data-intercom-target={dataIntercomTarget}
      css={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Link href={href} as={as} passHref={true} legacyBehavior={true}>
        <a
          css={mediaQueries({
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            padding: "8px 0 8px 24px",
            color: active ? palette.innovatorBlue : "#5A6677",
            fontWeight: active ? 600 : "normal",
            fontSize: 16,
            opacity: disabled ? 0.5 : 1,
          })}
          {...props}
        >
          {Icon && (
            <Margin mr={16}>
              <Icon width={24} height={24} color={active ? palette.innovatorBlue : "#5A6677"} />
            </Margin>
          )}
          {title}{" "}
          {!!count && count > 0 && !disabled && (active || alwaysShowCounter) && (
            <CountBadge
              css={{
                backgroundColor: "#5A6677",
                color: palette.white,
              }}
            >
              {count > 99 ? "99+" : count}
            </CountBadge>
          )}
        </a>
      </Link>

      {disabled && false && (
        <div
          css={{
            marginLeft: 12,
          }}
        >
          <PlanIcon width={24} height={24} />
        </div>
      )}
    </div>
  );
}
